import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-datepicker1',
  templateUrl: './datepicker.component.html',
  styleUrl: './datepicker.component.scss'
})
export class DatepickerComponent implements OnInit {
  @Input({ required: true }) placeholder!: string;
  @Input({ required: true }) control!: FormControl;

  value: any;

  constructor(private cdr: ChangeDetectorRef) { }  // Inject ChangeDetectorRef


  ngOnInit(): void {
    this.control.valueChanges.subscribe((value: unknown) => {
      if (value === null || value === undefined || value === '') {
        this.value = null;
        this.cdr.detectChanges();
        return;
      }
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        this.value = value;
        this.cdr.detectChanges();
        return;
      }
      const start = (value as { startDate?: { format: (f: string) => string } })?.startDate?.format('YYYY-MM-DD');
      if (!start) {
        this.value = null;
      } else {
        this.value = start;
      }
      this.cdr.detectChanges();
    });

    if (this.control.value) {
      this.value = this.control.value;
    }
  }

  onTimeChange(event: any): void {
    const time = event.hour + ':' + event.minute + ' ' + event.meridiem;
    const datetime = new Date('1993-12-23T' + time);
    this.control.setValue(datetime);
  }

  onValueChange(event: any): void {
    if (!event.startDate) return;

    const start = event.startDate?.format('YYYY-MM-DD');
    this.control.setValue(start);
  }

  resetPicker(): void {
    this.control.setValue(null);
    this.value = null;
  }
}
